import { handleEvent } from '../../helpers';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class {
  constructor(el) {
    this.el = el;
    this.modal = document.getElementById('gate-modal');
    this.thankyou = document.getElementById('thank-you-modal');
    this.storage = window.localStorage;
    this.isSuccess = this.el.getAttribute('data-success');
    this.isModal = this.el.getAttribute('data-modal');
  }

  init() {
    this.bootGate();
    this.handleEvents();
  }

  bootGate() {

    // if the gate is passed, don't do any of
    // this logic to check and set anything
    if (this.storage.getItem('fandom-gate-passed')) {
      return;
    }

    // get the params, look for success and true
    if(this.isSuccess == 'true' && this.isModal == 'true') {
      this.storage.setItem('fandom-gate-passed', new Date());
      const scope = this;
      setTimeout(function() {
        scope.thankyou.classList.add('show');
      }, 1000);
    } else {
      const scope = this;
      setTimeout(function() {
        scope.showModal();
      }, 1000);
    }

  }

  handleEvents() {
    this.closeButton = handleEvent('click', {
      el: document.getElementById('modalCloseButton'),
      preventDefault: true,
      stopPropagation: false,
      callback: this.closeModal.bind(this)
    });

    this.closeOverlay = handleEvent('click', {
      el: document.getElementById('modalCloseOverlay'),
      preventDefault: true,
      stopPropagation: false,
      callback: this.closeModal.bind(this)
    });
  }

  showModal() {
    this.modal.classList.add('show');
    disableBodyScroll(this.el.querySelector('scroller'));
  }

  // close modal if:
  // - passed, yes
  // - cancel or close, redirect to /news?
  closeModal(el) {
    clearAllBodyScrollLocks();
    this.modal.classList.remove('show');
    this.thankyou.classList.remove('show');
  }

}
